import { toast } from "react-toastify";
import { UpdateCompanyInfoAPI, UpdateImageCompanyAPI, UpdateSituationAPI, GetCompany } from "../../../API/CompaniesAPI";
import { CompanyModel } from "../../../Models/CompanyModel";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { IoClose } from "react-icons/io5";
import { useRef, useState, useContext, useEffect } from "react";
import useCan from "../../../Hooks/useCan";
import { ISelectProps } from "../../../Interfaces/ISelectProps";
import { AllPotentialMapping } from "../../../Utils/AllPotentialMapping";
import { AllStatus } from '../../../Utils/AllContratTypes';
import { AllSteps } from '../../../Utils/AllSteps';
import Select from "react-select";
import AntDialog from "../../dialogs/dialog";
import { Button, Typography } from "antd";
import { CompanyContext } from "../../../Contexts/CompanyContext";
interface IModalEditCompanyProps {
    showModal: boolean,
    toggleShowModal: () => void,
    loading: boolean,
    toggleLoading: (data: boolean) => void,
    company: CompanyModel,
    userEmail: string,
    companyLogoUrl: string,
    getCompany: (id: string) => Promise<void>
    getCompanyLogo: () => Promise<void>
}
interface FormSubmitProps {
    cnpj: string;
    city: string;
    postalCode: string;
    address: string;
    file: FileList;
}
export default function ModalEditCompany({ showModal, toggleShowModal, loading, toggleLoading, userEmail, getCompany, getCompanyLogo, companyLogoUrl }: IModalEditCompanyProps) {
    const canView = useCan({ rolesCan: [''] });
    const canViewSituation = useCan({ rolesCan: ["Manager", "Consultant"] });
    const { company } = useContext(CompanyContext);
    const formRef = useRef<HTMLFormElement>();
    const [showFile, setShowFile] = useState<boolean>(!!company.photoURL);
    const [potential, setPotential] = useState<ISelectProps>({ value: "defaultPotential", label: "Baixo volume de Projetos" });
    const [contractTypeText, setContractTypeText] = useState<string>("");
    const [stepsText, setStepsText] = useState<string>("");
    const [previewImage, setPreviewImage] = useState<string | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    useEffect(() => {
        setPreviewImage(companyLogoUrl)
    }, [companyLogoUrl]);

    const addCacheBuster = (url: string) => {
        return `${url.split('?')[0]}?t=${Date.now()}`;
    };

    const [contractType, setContractType] = useState<ISelectProps>(() => {
        let contract = {} as ISelectProps;
        if (company.contractType != null) {
            contract = AllStatus[company.contractType];
            setContractTypeText(contract.value);
        }
        return contract;
    });

    const [steps, setSteps] = useState<ISelectProps>(() => {
        let step = {} as ISelectProps;
        if (company.processStep != null) {
            step = AllSteps[company.processStep];
            setStepsText(step.value);
        }
        return step;
    });

    const schema = yup.object().shape({
        cnpj: yup.string().max(100, "Limite de caracteres excedido! Limite: 100 Caracteres").default(company.cnpj),
        city: yup.string().max(500, "Limite de caracteres excedido! Limite: 500 Caracteres").default(company.city),
        postalCode: yup.string().max(10, "Limite de caracteres excedido! Limite: 500 Caracteres").default(company.postalCode),
        address: yup.string().max(500, "Limite de caracteres excedido! Limite: 500 Caracteres").default(company.address),
        file: yup.mixed<FileList>()
    });

    const { register, handleSubmit, formState: { errors }, setValue } = useForm<FormSubmitProps>({
        resolver: yupResolver(schema)
    });

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];

            if (!file.type.startsWith('image/')) {
                toast.error('Por favor, selecione um arquivo de imagem valido');
                return;
            }
            console.log("FileBefore:", file);
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onload = () => {
                setPreviewImage(reader.result as string);
            };
            reader.readAsDataURL(file);
            setShowFile(true);
        }
    };

    const removeImage = () => {
        setPreviewImage(null);
        setSelectedFile(null);
        setShowFile(false);
        setValue("file", null as any);
    };

    const sendInfos = async (data: FormSubmitProps) => {
        try {
            toggleLoading(true);

            console.log("Data:", selectedFile);
            if (selectedFile) {
                await UpdateImageCompanyAPI(selectedFile, company.id, userEmail);
            }
            await UpdateCompanyInfoAPI(
                userEmail,
                company.id,
                data.cnpj,
                data.city,
                data.postalCode,
                data.address,
                potential.value)
                .then(async (resp: IResponseProps) => {
                    if (resp.statusCode === 200) {
                        if (canViewSituation) {
                            await UpdateSituationAPI(company.id, contractTypeText, stepsText, userEmail);
                        }
                        await getCompany(company.id);
                        toggleShowModal();
                        toast.success(`Empresa ${company.name} atualizada com sucesso!`);
                    }
                });
        } catch (error: any) {
            toast.error(error.message || "Erro ao atualizar empresa");
            console.error("Erro:", error);
        } finally {
            getCompanyLogo();
            toggleLoading(false);
        }
    };

    return (
        <AntDialog open={showModal} setOpen={toggleShowModal} modalProps={{ style: { minWidth: '78vw' } }}>
            <AntDialog.Header closeButton>
                <div style={{ display: 'flex', width: '100%' }}>
                    <Typography style={{ fontSize: '18px' }}>Editar empresa</Typography>
                </div>
            </AntDialog.Header>
            <AntDialog.Body>
                <form ref={formRef as any} onSubmit={handleSubmit(sendInfos)} autoComplete='false'>
                    <div style={{ display: 'grid', gridTemplate: '100% / 300px 1fr' }}>
                        <div style={{ height: '100%', margin: '16px 0px' }}>
                            <div style={{ width: '100%', textAlign: 'center', height: '9%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px 0px 5px 0px' }}>
                                {showFile && (
                                    <Button style={{ margin: '0px 14px 0px auto' }} onClick={removeImage}><IoClose /></Button>
                                )}
                            </div>
                            {showFile ? (
                                <div style={{ height: '90%', width: '100%' }}>
                                    <img
                                        style={{ width: '95%', height: '89%', borderRadius: '5px', objectFit: 'contain' }}
                                        src={previewImage ? previewImage : 'img/logo-default.png'}
                                        alt="logo-empresa"
                                        onError={(e) => {
                                            (e.target as HTMLImageElement).src = 'img/logo-default.png';
                                        }}
                                    />
                                </div>
                            ) : (
                                <input
                                    className='form-control'
                                    accept="image/*"
                                    type="file"
                                    onChange={handleImageChange}
                                />
                            )}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="d-flex align-items-center mb-1">
                                <div className="w-100 me-1">
                                    <Typography style={{ paddingLeft: '5px' }} className="required">CNPJ:</Typography>
                                    <input disabled={!canView} defaultValue={company.cnpj} {...register("cnpj")} className='form-control w-100' type="text" />
                                    <p className='error-message'>{errors.cnpj?.message}</p>
                                </div>
                                <div className="w-100 ms-1">
                                    <Typography style={{ paddingLeft: '5px' }} className="required">CEP:</Typography>
                                    <input defaultValue={company.postalCode} {...register("postalCode")} className='form-control w-100' type="text" />
                                    <p className='error-message'>{errors.postalCode?.message}</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center mb-1">
                                <div className="w-100 me-1">
                                    <Typography style={{ paddingLeft: '5px' }} className="required">Cidade:</Typography>
                                    <input defaultValue={company.city} {...register("city")} className='form-control' type="text" />
                                    <p className='error-message'>{errors.city?.message}</p>
                                </div>
                                <div className="w-100 ms-1">
                                    <Typography style={{ paddingLeft: '5px' }} className="required">Endereço:</Typography>
                                    <input defaultValue={company.address} {...register("address")} className='form-control' type="text" />
                                    <p className='error-message'>{errors.address?.message}</p>
                                </div>
                            </div>
                            <div>
                                <Typography style={{ paddingLeft: '5px' }} className="required">Volume de Projetos:</Typography>
                                <Select
                                    value={potential}
                                    className="w-100"
                                    options={AllPotentialMapping}
                                    onChange={(e: ISelectProps | null) => {
                                        if (e) {
                                            setPotential(e);
                                        }
                                    }}
                                    classNamePrefix="select"
                                    placeholder="Selecione o volume de projetos"
                                />
                            </div>
                            <div className="d-flex align-items-center mb-1 mt-4">
                                <div className="w-100 me-1">
                                    <Typography style={{ paddingLeft: '5px' }}>Tipo de Contrato:</Typography>
                                    <Select
                                        onChange={(e: any) => { setContractType(e); setContractTypeText(e.value) }}
                                        value={contractType}
                                        options={AllStatus}
                                        isDisabled={!canViewSituation}
                                        className="w-100"
                                        classNamePrefix="select"
                                    />
                                </div>
                                <div className="w-100 ms-1">
                                    <Typography style={{ paddingLeft: '5px' }}>Etapa Atual do Processo:</Typography>
                                    <Select
                                        onChange={(e: any) => { setSteps(e); setStepsText(e.value) }}
                                        value={steps}
                                        options={AllSteps}
                                        isDisabled={!canViewSituation}
                                        className="w-100"
                                        classNamePrefix="select"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </AntDialog.Body>
            <AntDialog.Footer>
                <div className="d-flex justify-content-between">
                    <Button onClick={toggleShowModal} style={{ width: '50%', marginRight: "8px" }}>
                        Cancelar
                    </Button>
                    <Button
                        style={{ width: '50%' }}
                        onClick={() => formRef.current?.requestSubmit()}
                        type="primary"
                    >
                        Salvar Informações
                    </Button>
                </div>
            </AntDialog.Footer>
        </AntDialog>
    );
}